import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Localized } from "@fluent/react";

export const SimpleMeetingMinutesReportSelect = ({
    value,
    onChange,
    operationalDashboardReport = false,
}: {
    value: string
    onChange: (value: string) => void
    operationalDashboardReport?: boolean
}) => {
    return (
        <FormControl fullWidth variant="outlined">
            <InputLabel id="report-select-label">
                <Localized id="report-select-label">_Wybierz raport</Localized>
            </InputLabel>
            <Select
                value={value}
                size="small"
                onChange={(e) => onChange(e.target.value)}
                label={<Localized id="report-select-label">_Wybierz raport</Localized>}
            >
                {operationalDashboardReport && (
                    <MenuItem value="OPERATIONAL_REPORT">
                        <Localized id="operational-dashboard-operational-report">_Raport Operacyjny</Localized>
                    </MenuItem>
                )}
                {operationalDashboardReport && (
                    <MenuItem value="OPERATIONAL_REPORT_WITH_HISTORY">
                        <Localized id="operational-dashboard-operational-report-with-history">_Raport Operacyjny z historią </Localized>
                    </MenuItem>
                )}
                {!operationalDashboardReport && <MenuItem value="MEETING">Spotkanie (tylko omówione tematy na spotkaniu)</MenuItem>}
                {!operationalDashboardReport && <MenuItem value="FULL">Pełny raport (tematy ze wszystkich spotkań z pełną historią)</MenuItem>}
                {!operationalDashboardReport && <MenuItem value="FULL_NO_HISTORY">Pełny bez historii (tematy ze wszystkich spotkań, tylko ostatni wpis stanu)</MenuItem>}
                {!operationalDashboardReport && <MenuItem value="ACTIVE_NOHISTORY">Aktywne bez historii (aktywne tematy ze wszystkich spotkań, tylko ostatni wpis stanu)</MenuItem>}
                {!operationalDashboardReport && <MenuItem value="ACTIVE_FULLHISTORY">Aktywne z pełną historią (aktywne tematy ze wszystkich spotkań z pełną historią)</MenuItem>}
            </Select>
        </FormControl>
    );
};
